import I18nLoader from '../I18nLoader';
import { RECEIVE_LOCALE } from '../constants';

const initialState = {
  isLoading: true
};

export default function i18n(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_LOCALE: {
      const loader = new I18nLoader(action.locale);
      return {
        ...state,
        isLoading: false,
        locale: loader.locale,
        messages: loader.messages
      };
    }
    default: {
      return state;
    }
  }
}
